(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('notificationSetup', notificationSetup);

    notificationSetup.$inject = ['$timeout', 'UserService', 'Message', 'notificationHelper', 'nounEndingHelper', 'localStorageService', 'moment', '_', 'toastHelper'];

    /* @ngInject */
    function notificationSetup($timeout, UserService, Message, notificationHelper, nounEndingHelper, localStorageService, moment, _, toastHelper) {
        var showToast = false, notificationShowed = false;
        var seconds = 250;
        var image = 'http://www.garnasport.ru/img/logo-footer.png';

        var service = {
            run: run
        };
        return service;

        ////////////////

        function run() {
            $timeout(loadData, 5000);
        }

        function loadData() {

            if(!UserService.hasUser()) {
                $timeout(loadData, 5000);
                return;
            }
            loadUnreadMessages()
                .then(function(items) {
                    if(_.size(items) == 0) {
                       return false;
                    }
                    var body = '';
                    var clients = nounEndingHelper.getNoun(_.size(items), ['клиенту', 'клиентам', 'клиентам']);
                    if(UserService.isManager()) {
                        body = 'У Вас есть непрочитанные сообщения по проекту №' +items[0].order_id + (_.size(items)-1 > 0 ? (' и еще ' + (_.size(items)-1) + ' ' + clients) : '');
                    } else {
                        body = 'Есть непрочитанные сообщения по проекту №' +items[0].order_id + (_.size(items)-1 > 0 ? (' и еще ' + (_.size(items)-1) + ' ' + clients) : '');
                    }
                    var tag = _.reduce(items, function(res, item) {
                            return res + item.cuser+':'+moment(item.first_time, 'YYYY-MM-DD HH::mm::ss').unix()+'|';
                        }, 'msg|');
                    sendNotification("GarnaSport", body, tag);
                    return true;
                })
                .then(function(send) {
                    $timeout(loadData, 60000);
                });
        }

        function loadUnreadMessages() {
            var params = {};
            if(UserService.isManager()) {
                params.my = 1;
            }
            return Message.get(params)
                .$promise
                .then(function (response) {
                    return response.object;
                }, function () {
                    return [];
                });
        }

        function sendNotification(title, body, tag) {
            if(!showToast) {
                sendBrowserNotification(title, body, tag);
            } else {
                sendToastNotification(title, body, tag);
            }
        }

        function sendBrowserNotification(title, body, tag) {

            var storageNotification = localStorageService.get(tag);
            if(storageNotification != null && storageNotification.body == body && moment().diff(moment(storageNotification.time, 'DD.MM.YY HH:mm:ss'), 'seconds') < seconds) {
                return;
            }
            var notification = notificationHelper.notify(title, body, tag, image);
            if (notification) {
                /* notification.onclick = function () {
                 console.log('notification.Click');
                 };*/
                notification.onerror = function () {
                    //console.log('error notice');
                    showToast = true;
                    sendToastNotification(title, body, tag);
                };
                notification.onshow = function () {
                    //console.log('show notice');
                    localStorageService.set(tag, {time: moment().format('DD.MM.YY HH:mm:ss'), body: body});
                    notificationShowed = true;
                    showToast = false;

                    $timeout(function () {
                        notification.close();
                    }, 5000);

                    $timeout(function () {
                        localStorageService.remove(tag);
                    }, 1000 * seconds);
                };
                notification.onclose = function () {
                    //console.log('close notice');
                };

                if(!notificationShowed) {
                    $timeout(function () {
                        if(!notificationShowed) {
                            if(image == '') {
                                showToast = true;
                            } else {
                                image = '';
                            }
                            sendNotification(title, body, tag);
                        }
                    }, 1000);
                }


            } else {
                showToast = true;
                sendToastNotification(title, body, tag);
            }
        }

        function sendToastNotification(title, body, tag) {
            toastHelper.show(title+body);
        }
    }

})();

